import React from "react";
import { useLang } from "../i18n";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#2D3640] text-[#FDFAF3]/80 py-14">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-3 gap-10">
        <div>
          <div className="font-serif-display text-2xl text-[#FDFAF3]">Porto <span className="font-script text-[#C98C97]">beyond</span></div>
          <p className="mt-3 text-sm leading-relaxed max-w-sm">{t.footer.tagline}</p>
        </div>
        <div className="text-sm">
          <p className="uppercase tracking-[0.22em] text-[#C98C97] text-xs mb-3">Explore</p>
          <ul className="space-y-2">
            <li><a href="#story" className="hover:text-white">{t.nav.story}</a></li>
            <li><a href="#route" className="hover:text-white">{t.nav.route}</a></li>
            <li><a href="#pricing" className="hover:text-white">{t.nav.pricing}</a></li>
            <li><a href="#booking" className="hover:text-white">{t.nav.book}</a></li>
          </ul>
        </div>
        <div className="text-sm">
          <p className="uppercase tracking-[0.22em] text-[#C98C97] text-xs mb-3">Contact</p>
          <ul className="space-y-2">
            <li><a href="https://wa.me/351931777823?text=Hello%21%20I%20would%20like%20more%20information%20about%20Porto%20Beyond%20the%20Postcard." target="_blank" rel="noreferrer" className="hover:text-white">WhatsApp · +351 931 777 823</a></li>
            <li><a href="https://www.instagram.com/portobeyondpostcards" target="_blank" rel="noreferrer" className="hover:text-white">@portobeyondpostcards</a></li>
            <li><Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white">{t.nav.admin}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 mt-10 pt-6 text-center text-xs text-[#FDFAF3]/50">
        © {new Date().getFullYear()} Porto Beyond the Postcard · {t.footer.made}
      </div>
    </footer>
  );
}
